import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import {jobStatusMapping} from "../common/formatting";
import { GET_SITE, UPDATE_SITE } from "./actions.type";

const SiteModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
  },
  mutations:{

  },
  getters: {

  },
  actions: {
    [GET_SITE](context,payload){
      return new Promise((resolve,reject)=>{
           ApiService.get('/sites/'+payload.site_id)
             .then(({data}) => {
               data.data.jobs.map(ele => {
                ele.status = jobStatusMapping[ele.status - 1];
              });
               resolve(data)
             })
             .catch(({response})=>{
               reject(response);
             })
        }
      );
    },
    [UPDATE_SITE](context,payload){
      let params = payload.data.params;
      return new Promise((resolve,reject) => {
        ApiService.put('/sites/'+payload.data.site_id,{
          email:params.email,
          phone:params.phone,
          address:params.address,
          state:params.state,
          suburb:params.suburb,
        }).then(({data}) => {
          resolve(data);
        })
          .catch(({response}) => {
            reject(response.data);
          });
      });
    }
  },
};

export default SiteModule;
